(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milupets-care-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('milupets-care-story')) {
    customElements.define('milupets-care-story', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.loadObserver?.disconnect();
        this.controller?.abort();
        this.controller = new AbortController();
        const preference = matchMedia('(prefers-reduced-motion: reduce)');
        const videos = this.querySelectorAll('[data-reference-video], [data-original-demo]');
        if (!('IntersectionObserver' in window)) return;

        // Keep real sources for native playback without JavaScript; warm up only nearby demos.
        this.loadObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const video = entry.target;
            video.preload = 'metadata';
            if (video.readyState === 0 && video.paused) video.load();
            this.loadObserver.unobserve(video);
          }
        }, { rootMargin:'300px 0px' });
        this.querySelectorAll('[data-original-demo]').forEach(video => this.loadObserver.observe(video));

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) entry.target.pause();
            else if (entry.intersectionRatio >= 0.35 && !preference.matches) entry.target.play().catch(() => {});
          }
        }, { threshold:[0, 0.35] });
        videos.forEach(video => this.observer.observe(video));
        preference.addEventListener('change', () => {
          if (preference.matches) videos.forEach(video => video.pause());
        }, { signal:this.controller.signal });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.loadObserver?.disconnect();
        this.controller?.abort();
        this.querySelectorAll('[data-reference-video], [data-original-demo]').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milupets-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('milu-home-gallery')){customElements.define('milu-home-gallery',class extends HTMLElement{connectedCallback(){this.onclick=(event)=>{const button=event.target.closest('button[data-direction]');if(!button)return;const track=this.querySelector('.mh-review-track');track.scrollBy({left:Number(button.dataset.direction)*(track.querySelector('figure').getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};}disconnectedCallback(){this.onclick=null;}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milupets-moments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('milupets-moments')) {
    customElements.define('milupets-moments', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.mpm-track');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.progress = this.querySelector('[data-progress]');
        this.controls = this.querySelector('.mpm-controls');
        this.dots = this.querySelector('[data-dots]');
        this.dots.addEventListener('click', (event) => {
          const button = event.target.closest('[data-page]');
          if (!button) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.track.scrollTo({left:Number(button.dataset.page) * this.step() * (rtl ? -1 : 1), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, { signal });
        this.prev.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.update(), { signal, passive:true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-slide]');
          if (!card) return;
          const cards = [...this.track.querySelectorAll('[data-slide]')];
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.track.scrollTo({left:cards.indexOf(card) * this.step() * (rtl ? -1 : 1), behavior:'instant'});
        }, { signal });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      step() {
        const card = this.track.querySelector('[data-slide]');
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : 1;
      }
      move(direction) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({left:direction * this.step() * (rtl ? -1 : 1), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offset = Math.abs(this.track.scrollLeft);
        this.controls.hidden = max < 2;
        this.prev.disabled = offset < 2;
        this.next.disabled = offset >= max - 2;
        const total = Math.ceil(Math.max(0,max - 2) / this.step()) + 1;
        const current = this.next.disabled ? total : Math.min(total,Math.round(offset / this.step()) + 1);
        if (this.dots.children.length !== total) {
          this.dots.replaceChildren();
          for (let i=0;i<total;i++) {
            const button = document.createElement('button');
            button.type = 'button'; button.dataset.page = String(i);
            button.setAttribute('aria-label', `${this.dots.dataset.label} ${i+1}`);
            this.dots.append(button);
          }
        }
        [...this.dots.children].forEach((button,i) => button.setAttribute('aria-current', String(i === current-1)));
        const value = `${current} / ${total}`;
        if (this.progress.textContent !== value) this.progress.textContent = value;
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milupets-page"]) return;
  try {
    
if(!customElements.get('milu-tracking'))customElements.define('milu-tracking',class extends HTMLElement{
 connectedCallback(){this.handler=async(event)=>{event.preventDefault();const form=event.target;const number=form.elements.tracking.value.trim();if(!number)return;const button=form.querySelector('button');const error=this.querySelector('.mp-track-error');error.hidden=true;button.disabled=true;try{if(!window.YQV5){await new Promise((resolve,reject)=>{let script=document.getElementById('milu-17track-script');if(!script){script=document.createElement('script');script.id='milu-17track-script';script.src='https://www.17track.net/externalcall.js';script.onload=resolve;script.onerror=()=>{script.remove();reject(new Error('load'));};document.head.append(script);}else{script.addEventListener('load',resolve,{once:true});script.addEventListener('error',reject,{once:true});}});}window.YQV5.trackSingle({YQ_ContainerId:this.querySelector('.mp-track-result').id,YQ_Height:560,YQ_Fc:'0',YQ_Lang:'en',YQ_Num:number});}catch{error.textContent=this.dataset.error;error.hidden=false;}finally{button.disabled=false;}};this.querySelector('form').addEventListener('submit',this.handler);}
 disconnectedCallback(){this.querySelector('form')?.removeEventListener('submit',this.handler);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milupets-reviews"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('milupets-review-carousel'))customElements.define('milupets-review-carousel',class extends HTMLElement{
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
  this.track=this.querySelector('.ml-review-track');this.cards=[...this.querySelectorAll('.ml-review')];this.dots=[...this.querySelectorAll('[data-slide]')];
  this.querySelector('.ml-controls').hidden=false;
  this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-slide'))this.move(+b.dataset.slide);else if(b.dataset.step)this.move(this.index+ +b.dataset.step);},{signal});
  this.track.addEventListener('scroll',()=>this.sync(),{passive:true,signal});
  this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(this.index+(e.key==='ArrowRight'?1:-1));}},{signal});
  this.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(c=>c===e.target||c.contains(e.target));if(i>=0)this.move(i);},{signal});
  this.observer?.disconnect();this.observer=new ResizeObserver(()=>this.sync());this.observer.observe(this.track);this.sync();
 }
 sync(){if(!this.cards.length)return;const step=this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);this.step=step;this.max=Math.max(0,Math.ceil((this.track.scrollWidth-this.track.clientWidth-2)/step));this.index=Math.min(this.max,Math.round(this.track.scrollLeft/step));this.dots.forEach((d,i)=>{d.hidden=i>this.max;d.setAttribute('aria-current',String(i===this.index));});this.querySelector('[data-step="-1"]').disabled=this.index===0;this.querySelector('[data-step="1"]').disabled=this.index>=this.max;}
 move(i){this.track.scrollTo({left:Math.max(0,Math.min(this.max,i))*this.step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
 disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
});


  } catch(e) { console.error(e); }
})();
})();
